import { z } from "zod";

export enum CaseTaxCalStatus {
  IDLE = "IDLE",
  TAX_ENGINE_SCHEDULED = "TAX_ENGINE_SCHEDULED",
  TAX_ENGINE_IN_PROGRESS = "TAX_ENGINE_IN_PROGRESS",
  TRANSFER_DETECTION_IN_PROGRESS = "TRANSFER_DETECTION_IN_PROGRESS",
  FILE_INGESTION_IN_PROGRESS = "FILE_INGESTION_IN_PROGRESS",
}

export const caseTaxCalStatusSchema = z.object({
  caseStatus: z.union([z.nativeEnum(CaseTaxCalStatus), z.string()]),
});

export type CaseTaxCal = z.infer<typeof caseTaxCalStatusSchema>;
